import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { TaskSelectedPayload } from './interfaces/task-selected-payload.interface';
import { isNonNullObject } from 'utilities';

export const TaskSelectedMessage: MessageHandler<TaskSelectedPayload> = {
  send(payload: TaskSelectedPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.TaskSelected, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is TaskSelectedPayload {
    if (!isNonNullObject(payload)) return false;
    const p = payload as Record<string, unknown>;
    return (
      typeof p['team'] === 'string' &&
      p['team'].length > 0 &&
      typeof p['project'] === 'string' &&
      p['project'].length > 0 &&
      typeof p['task'] === 'string' &&
      p['task'].length > 0 &&
      (p['scene'] === undefined || typeof p['scene'] === 'string')
    );
  },
};
